//const baseURL = process.env.REACT_APP_API_BASE_URL;
// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // console.log(baseURL);
// export const BASE_URL = `http://localhost:9000/api/v1`;
// export const BASE_URL_FOR_FILE = `http://localhost:9000/uploads`;
// export const BASE_URL_SOCKET = `http://localhost:8080`; 



// export const BASE_URL = `http://210.89.45.45:1040/api/v1`;


// sars hms 
// export const BASE_URL = 'https://hms.sarserp.com:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'https://hms.sarserp.com:8000/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';


//amar
// export const BASE_URL = 'http://192.168.1.100:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.100:8000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.100:8080';

// //RR Hospital
// export const BASE_URL = 'https://rrhospital.sarserp.com:1100/api/v1';
// export const BASE_URL_FOR_FILE = 'https://rrhospital.sarserp.com:1100/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';


//cheema
//  export const BASE_URL = 'http://192.168.29.140:9000/api/v1';
//  export const BASE_URL_FOR_FILE = 'http://192.168.29.140:9000/uploads';
//  export const BASE_URL_SOCKET = 'http://192.168.29.140:8080';

//Taneja
// export const BASE_URL = 'http://192.168.1.9:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.9:8000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';


//ujjivan
// export const BASE_URL = 'http://210.89.45.45:4000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:4000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

// export const BASE_URL = 'http://210.89.45.45:1020/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1020/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

//Budhana
// export const BASE_URL = 'http://192.168.1.48:9000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.48:9000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';


// export const BASE_URL = 'http://210.89.45.45:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:8000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';


// export const BASE_URL = 'http://210.89.45.45:1030/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1030/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

// export const BASE_URL = 'http://192.168.1.8:9000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://192.168.1.8:9000/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.29.2:8080';


// export const BASE_URL = 'http://210.89.45.45:1040/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1040/uploads';
// export const BASE_URL_SOCKET = 'http://192.168.1.9:8080';

// export const BASE_URL = 'http://210.89.45.45:5005/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:5005/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';




// // // Gill Hospital
// export const BASE_URL = 'https://gillhospital.sarserp.com:9005/api/v1';
// export const BASE_URL_FOR_FILE = 'https://gillhospital.sarserp.com:9005/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';


// export const BASE_URL = 'http://210.89.45.45:10001/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:10001/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080';


// export const BASE_URL = 'http://210.89.45.45:8000/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:8000/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

//Sumit
// export const BASE_URL = 'https://sumithospital.sarserp.com:10004/api/v1';
// export const BASE_URL_FOR_FILE = 'https://sumithospital.sarserp.com:10004/uploads';
// export const BASE_URL_SOCKET = 'http://103.180.213.13:8080'

// export const BASE_URL = 'http://210.89.45.45:10004/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:10004/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'



//Taneja
// export const BASE_URL = 'https://tanejahospital.sarserp.com:11005/api/v1';
// export const BASE_URL_FOR_FILE = 'https://tanejahospital.sarserp.com:11005/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

//Godavari Hospital
// export const BASE_URL = 'https://maagodavarihospital.sarserp.com:1104/api/v1';
// export const BASE_URL_FOR_FILE = 'https://maagodavarihospital.sarserp.com:1104/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'


//Aastha Hospital
// export const BASE_URL = 'https://aasthahospital.sarserp.com:11102/api/v1';
// export const BASE_URL_FOR_FILE = 'https://aasthahospital.sarserp:11102/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'


//Jain Hospital
// export const BASE_URL = 'http://210.89.45.45:1005/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:1005/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

//AR Mittal Hospital
// export const BASE_URL = 'https://armittal.sarserp.com:11103/api/v1';
// export const BASE_URL_FOR_FILE = 'https://armittal.sarserp.com:11103/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

//Narendra Plus Hospital
// export const BASE_URL = 'https://narendraplus.sarserp.com:11104/api/v1';
// export const BASE_URL_FOR_FILE = 'https://narendraplus.sarserp.com:11104/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

// //Sumit Hospital
// export const BASE_URL = 'http://210.89.45.45:10004/api/v1';
// export const BASE_URL_FOR_FILE = 'http://210.89.45.45:10004/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'


//Surbhi Hospital
// export const BASE_URL = 'https://surbhihospital.sarserp.com:11105/api/v1';
// export const BASE_URL_FOR_FILE = 'https://surbhihospital.sarserp.com:11105/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

//Surbhi Hospital
// export const BASE_URL = 'https://dmrhospital.sarserp.com:11106/api/v1';
// export const BASE_URL_FOR_FILE = 'https://dmrhospital.sarserp.com:11106/api/v1';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'


//Jistendrahospital Hospital
// export const BASE_URL = 'https://jitendrahospital.sarserp.com:1180/api/v1';
// export const BASE_URL_FOR_FILE = 'https://jitendrahospital.sarserp.com:1180/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

//Dr. Amit Super Speciality Hospital and Trauma Centre
export const BASE_URL = 'https://dramitss.sarserp.com:11107/api/v1';
export const BASE_URL_FOR_FILE = 'https://dramitss.sarserp.com:11107/uploads';
export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'


// gurunanak
// export const BASE_URL = 'https://gurunanakhospital.sarserp.com:1313/api/v1';
// export const BASE_URL_FOR_FILE = 'https://gurunanakhospital.sarserp.com:1313/uploads';
// export const BASE_URL_SOCKET = 'http://210.89.45.45:8080'

